import { $form, $view, $detail } from 'signals/global.signals';
import { createRoomView } from 'api/rooms.api';
import { createDealflow } from 'api/dealflow.api';
import getSelectValue from 'utils/getSelectValue';
import displayNotification from 'utils/displayNotification';
import { fetchAndSetPublicDealData } from 'components/views/PublicRoom/_helpers/publicRoom.resolvers';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import displayError from 'utils/displayError';

/* ---- API EVENTS ----*/
export const handleSubmitAddToPipeline = async () => {
  try {
    $view.update({
      isModalLoading: true,
    });
    await createDealflow({
      dealId: Number($detail.value.dealId),
      pipelineStatus: getSelectValue($form.value.status),
      rating: getSelectValue($form.value.rating),
      teamId: getSelectValue($form.value.teamId),
    });
    displayNotification({
      message: 'Deal added to pipeline',
      variant: 'success',
    });
    handleHideModal();
    await fetchAndSetPublicDealData({ id: Number($detail.value.id) });
  } catch (error) {
    displayError({
      message: 'Failed to add deal to pipeline. Please try again.',
      title: 'Pipeline Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

export const handleSubmitView = async (id) => {
  try {
    await createRoomView(id, {
      email: $form.value.email,
    });
  } catch (error) {
    displayError({
      message: 'Failed to register room view. Please try again.',
      title: 'View Error',
    });
  }
};

/* ---- UI EVENTS ----*/
export const handleBackClick = () => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete('tab');
  window.history.pushState(null, null, `?${queryParams.toString()}`);
  $view.update({
    activeTab: 'lander',
  });
};

export const handleMenuItemClick = ({ tab, isShowFadeIn = false }) => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.set('tab', tab);
  if (tab === null) {
    window.history.pushState(null, null, window.location.pathname);
  } else {
    window.history.pushState(null, null, `?${queryParams.toString()}`);
  }
  $view.update({
    ...$view.value,
    activeTab: tab,
    isShowFadeIn,
  });
};
